export const SET_NAV_OPEN = 'SET_NAV_OPEN';
export const SET_NAV_STRUCTURE = 'SET_NAV_STRUCTURE';
